import { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { IMaskInput } from 'react-imask';
import { CURRENCY } from '@/helpers/constants';
import IconClear from './icon_clear.svg';
import s from './index.module.scss';

export const MoneyField = ({
  label,
  name,
  value,
  placeholder,
  onChange,
  onClear,
  error,
  className,
  description,
  rightContainer,
  isFloat,
}) => {
  const maskedValue = useRef(value.toString());

  useEffect(() => {
    maskedValue.current = value.toString();
  }, [value]);

  return (
    <div className={classnames(s.wrapper, className)}>
      {label && (
        <label id={name} htmlFor={name} className={classnames(s.label, 'f-small-regular')}>
          {label}
        </label>
      )}
      <div className={s.container}>
        <div className={s.left_container}></div>
        <IMaskInput
          mask={`${CURRENCY}num`}
          blocks={{
            num: {
              mask: Number,
              thousandsSeparator: "'",
              radix: isFloat ? '.' : undefined, // Use '.' as the decimal separator
              scale: isFloat ? 2 : 0, // Allow up to 2 decimal places if isFloat is true
              mapToRadix: [','], // Allow ',' as a decimal separator
              min: 0, // Avoid entering negative number
              max: 9999999, // Allow up to 7 digits
            },
          }}
          className={classnames(s.input, error && s.input_error)}
          value={maskedValue.current}
          placeholder={placeholder}
          onAccept={(value, mask) => {
            maskedValue.current = value;
            onChange(mask.unmaskedValue);
          }}
        />
        <div className={s.right_container}>
          {rightContainer ||
            (onClear && !!value && (
              <button type="button" className={s.btn_clear} onClick={onClear}>
                <img src={IconClear} width={24} height={24} alt="clear" />
              </button>
            ))}
        </div>
      </div>
      {error ? (
        <div className={classnames(s.error, 'f-small-regular')}>{error}</div>
      ) : (
        description && (
          <div className={classnames(s.description, 'f-small-regular')}>{description}</div>
        )
      )}
    </div>
  );
};
